import { GraphQLFieldConfig, GraphQLNonNull, GraphQLID } from 'graphql'
import { Context } from '../shared'
import { organization, Organization } from '../types/organization'
import { transformRole } from './helpers/role'
import { OrganizationType } from '../types/organization-type'

export const organizationDetails: GraphQLFieldConfig<any, Context> = {
  type: new GraphQLNonNull(organization),
  description: 'Get the organization for the current logged in user',
  args: {
    organizationID: {
      description: 'The uuid of organization',
      type: new GraphQLNonNull(GraphQLID)
    }
  },
  async resolve(_source, args, context): Promise<Organization> {
    const { organizationID } = args
    const {
      organization: {
        name,
        organization_uuid: id,
        freemium,
        properties: { restricted_edit_role }
      },
      roles,
      enterprise
    } = await context.connector.get(
      `/profile/organizations/${organizationID}?expand=freemium`
    )
    const restrictedEditRole = restricted_edit_role === 'true'
    const {
      breakdown: { unused, used }
    } = await context.connector.get(`/${id}/licenses`)

    const role = transformRole(roles)

    const enterpriseType: OrganizationType = enterprise
      ? 'Standard'
      : 'Restricted'
    const type: OrganizationType = freemium ? 'Freemium' : enterpriseType

    const org = {
      name,
      id,
      type,
      role,
      restrictedEditRole,
      assessLicenseBreakdown: {
        unused,
        used
      }
    }
    if (role !== 'ADMIN' && role !== 'RULES_ADMIN') {
      return org
    }

    const {
      user: { rasp_enabled: protect }
    } = await context.connector.get(`/${id}/profile`)

    if (!protect) {
      return org
    }

    const protectLicenses = await context.connector.get(
      `${id}/rasp/licenses?expand=skip_links`
    )

    return {
      ...org,
      protectLicenseBreakdown: {
        unused: protectLicenses.breakdown.unused,
        used: protectLicenses.breakdown.used
      }
    }
  }
}
